"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInvokeLogErrorEvent = exports.isHttpError = void 0;
exports.isHttpError = (obj) => typeof (obj === null || obj === void 0 ? void 0 : obj.statusCode) === 'number';
const getErrorMessage = (error) => typeof error === 'string' ? error : error === null || error === void 0 ? void 0 : error.message;
const getSub = (event) => { var _a, _b, _c; return (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.requestContext) === null || _a === void 0 ? void 0 : _a.identity) === null || _b === void 0 ? void 0 : _b.cognitoAuthenticationProvider) === null || _c === void 0 ? void 0 : _c.split(':')[2]; };
exports.createInvokeLogErrorEvent = ({ event, invokeEvent, api, functionName, error }) => {
    const sub = getSub(event);
    const logErrorEvent = {
        api,
        functionName,
        errorMessage: getErrorMessage(error)
    };
    if (process.env.AWS_LAMBDA_LOG_GROUP_NAME) {
        // Environemnt variable exists in AWS Lambda function
        logErrorEvent.logGroupName = process.env.AWS_LAMBDA_LOG_GROUP_NAME;
    }
    if (process.env.AWS_LAMBDA_LOG_STREAM_NAME) {
        // Environemnt variable exists in AWS Lambda function
        logErrorEvent.logStreamName = process.env.AWS_LAMBDA_LOG_STREAM_NAME;
    }
    if (exports.isHttpError(error)) {
        logErrorEvent.statusCode = error.statusCode;
    }
    if (sub) {
        logErrorEvent.sub = sub;
    }
    if (event && event.pathParameters) {
        logErrorEvent.pathParameters = event.pathParameters;
    }
    if (event && event.queryStringParameters) {
        logErrorEvent.queryStringParameters = event.queryStringParameters;
    }
    if (invokeEvent) {
        logErrorEvent.invokeEvent = invokeEvent;
    }
    return logErrorEvent;
};
//# sourceMappingURL=errors.js.map